// extracted by mini-css-extract-plugin
export default {"item":"TermsWall_item__SB6iU","link":"TermsWall_link__cWLF-"};